import { AccountNavigation } from "components/account/details/components/navigation/AccountNavigation";
import { Message } from "shared/components/Message";
import { accountMessages } from "domain/account/accountMessages";
import React, { FC } from "react";
import { Col, Row } from "reactstrap";

export const AccountTitle: FC = () => (
    <Row>
        <Col>
            <Row>
                <Col xs={12} md="auto">
                    <h1 className="h2" id="accountTitle">
                        <Message message={accountMessages.accountExistingPageTitle} />
                    </h1>
                </Col>
                <Col md={true} className="d-none d-md-block text-right mb-2">
                    <AccountNavigation className="mt-2 ml-1" size="sm" />
                </Col>
            </Row>
            <Row className="d-md-none mb-3">
                <Col xs={12}>
                    <AccountNavigation className="w-100 mt-1" />
                </Col>
            </Row>
            <Row aria-hidden="true">
                <Col>
                    <div className="border-bottom my-2 mb-3" />
                </Col>
            </Row>
        </Col>
    </Row>
);
